import { gql } from '@apollo/client';

export const CREATE_ABSCHNITT = gql`
  mutation mitarbeiter_createAbschnitt(
    $input: mitarbeiter_createAbschnittInput!
  ) {
    mitarbeiter_createAbschnitt(createAbschnittInput: $input) {
      success {
        abschnitt {
          id
          name
          position
        }
      }
      error {
        message
      }
    }
  }
`;
